import React from 'react'
import { withState } from 'react-state-hoc'

import { H1, Main, Footer } from '../primitives'
import ErrorForm from './ErrorForm'
import Result from './Result'

import { testReports } from '../tests'

const App = ({
	text,
	page,
	reset,
	updateText,
	uploadFile,
	uploadStatus,
	viewResults,
}) => (
	<Main>
		<H1 margin={20}>The Sims 4 lastException Assistant</H1>
		{page === 'result' ? (
			<Result text={text} reset={reset} />
		) : (
			<ErrorForm
				text={text}
				updateText={updateText}
				uploadFile={uploadFile}
				uploadStatus={uploadStatus}
				viewResults={viewResults}
			/>
		)}
		<Footer>0.4.1.{testReports.length.toString().padStart(3, "0")} - <a href="https://turbodriver.github.io/" target="_blank" rel="noopener noreferrer">TURBODRIVER</a> - 2018-2023<p>This site is not endorsed by or affiliated with Electronic Arts, or its licensors.</p></Footer>
	</Main>
)

const allowedFileTypes = ['text/plain', 'application/xml', 'text/xml', "text/html"]

const initialState = { error: null, text: '', uploadStatus: null, page: 'form' }

export default withState(initialState, () => setState => {
	const reader = new FileReader()

	reader.onload = e =>
		setState({
			page: 'result',
			text: e.target.result,
			uploadStatus: 'done',
		})

	return {
		reset: () => setState(initialState),
		updateText: e => setState({ text: e.target.value }),
		uploadFile: e => {
			setState({ error: null, uploadStatus: 'uploading' })

			const file = e.target.files[0]

			if (!allowedFileTypes.includes(file.type)) {
				setState({
					error: 'Unsupported file type. Upload a .txt or an .xml file.',
					uploadStatus: 'error',
				})
			}

			reader.readAsText(file)
		},
		viewResults: () => setState({ page: 'result' }),
	}
})(App)



// WEBPACK FOOTER //
// ./src/components/App.js